import { render, staticRenderFns } from "./MyLastQuestions.vue?vue&type=template&id=19651d4f&scoped=true&"
import script from "./MyLastQuestions.vue?vue&type=script&lang=ts&"
export * from "./MyLastQuestions.vue?vue&type=script&lang=ts&"
import style0 from "./MyLastQuestions.vue?vue&type=style&index=0&id=19651d4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19651d4f",
  null
  
)

export default component.exports